import { apiRequest } from '@/lib/api'
import { clearToken } from '@/lib/auth'

export async function getMe() {
  return apiRequest<{
    id: string
    name: string
    email: string
    role: 'super_admin' | 'general_admin'
    status: 'active' | 'inactive' | 'suspended'
    permissions: {
      can_view_financials: boolean
      can_manage_admins: boolean
      can_export_data: boolean
    }
  }>('/admin/auth/me')
}

export function redirectToLogin(redirectUrl?: string) {
  const url = new URL(window.location.origin + '/login')
  if (redirectUrl) url.searchParams.set('redirectUrl', redirectUrl)
  window.location.href = url.pathname + url.search
}

export function logout(redirectUrl?: string) {
  clearToken()
  if (redirectUrl) {
    redirectToLogin(redirectUrl)
  }
}
